var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54536 0.180208C9.39966 0.0635579 9.21859 0 9.03195 0C8.84531 0 8.66423 0.0635579 8.51853 0.180208C8.21459 0.459504 0 7.08047 0 13.9643C0 16.3608 0.95201 18.6592 2.6466 20.3538C4.34119 22.0483 6.63954 23.0004 9.03605 23.0004C11.4326 23.0004 13.7309 22.0483 15.4255 20.3538C17.1201 18.6592 18.0721 16.3608 18.0721 13.9643C18.0721 7.08047 9.85751 0.459504 9.54536 0.180208ZM9.03605 21.3574C7.07527 21.3574 5.1948 20.5785 3.80832 19.192C2.42184 17.8056 1.64292 15.9251 1.64292 13.9643C1.64292 8.7891 7.28635 3.4414 9.03605 1.89706C10.7858 3.4414 16.4292 8.7891 16.4292 13.9643C16.4292 15.9251 15.6503 17.8056 14.2638 19.192C12.8773 20.5785 10.9968 21.3574 9.03605 21.3574Z",
    fill: "#189FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03611 18.0713C7.94678 18.0713 6.90207 17.6386 6.13181 16.8683C5.36154 16.0981 4.92881 15.0534 4.92881 13.964C4.92881 13.7462 4.84226 13.5372 4.68821 13.3832C4.53415 13.2291 4.32521 13.1426 4.10735 13.1426C3.88948 13.1426 3.68054 13.2291 3.52649 13.3832C3.37244 13.5372 3.28589 13.7462 3.28589 13.964C3.28589 15.4891 3.89171 16.9517 4.97009 18.0301C6.04846 19.1084 7.51105 19.7143 9.03611 19.7143C9.25397 19.7143 9.46291 19.6277 9.61697 19.4737C9.77102 19.3196 9.85756 19.1107 9.85756 18.8928C9.85756 18.6749 9.77102 18.466 9.61697 18.3119C9.46291 18.1579 9.25397 18.0713 9.03611 18.0713Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBp);
export default __webpack_public_path__ + "static/media/Bp.d975f4963b94506f5c922b0257554dc8.svg";
export { ForwardRef as ReactComponent };